const INITIAL_STATE = {
  selectedCategories: [],
  renewCategories: 'all',
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case 'SELECTED_CATEGORIES_DATA':
      return {
        ...state,
        selectedCategories: payload,
      };
    case 'RENEW_CATEGORIES':
      return {
        ...state,
        renewCategories: payload,
      };
    case 'GET_CATEGORIES_DATA':
      return {
        ...state,
        ...payload,
      };
    case 'INITIAL_STATE':
      return INITIAL_STATE;
    default:
  }
  return state;
};
